// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { Handler, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { AddCartLinesApiParameter } from "@insite/client-framework/Services/CartService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/AddCartLines";
import { CartLineCollectionModel, CartLineModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = {
    productInfos: ProductInfo[];
} & HasOnSuccess<CartLineCollectionModel>;

type Props = {
    apiParameter: AddCartLinesApiParameter;
    apiResult: CartLineCollectionModel;
};

type HandlerType = Handler<Parameter, Props>;

export const xngPopulateApiParameter: HandlerType = props => {
    const cartLineCollection: CartLineModel[] = [];
    props.parameter.productInfos.forEach((o: ProductInfo) => {
        // XNG-CHANGES: replaced productId, unitOfMeasure and qtyOrdered with the
        //  coming object to allow passing properties and oothe fields
        cartLineCollection.push({
            // productId: o.productId,
            // qtyOrdered: o.qtyOrdered,
            // unitOfMeasure: o.unitOfMeasure,
            ...o,
        } as any);
    });

    cartLineCollection.forEach(line => {
        const parsedQty = line.qtyOrdered ? parseFloat(line.qtyOrdered.toString()) : 1;
        line.qtyOrdered = parsedQty > 0 ? parsedQty : 1;
    });

    props.apiParameter = {
        cartLineCollection: {
            cartLines: cartLineCollection,
        },
        cartId: API_URL_CURRENT_FRAGMENT,
    } as AddCartLinesApiParameter;
};

replaceInChain(chain, PopulateApiParameter, xngPopulateApiParameter);
